import { http } from "./http";
import { SignInRequest, SignInResponse, SignUpRequest } from "@/types/api/auth";

export async function signIn(req: SignInRequest): Promise<SignInResponse> {
  return http.post<SignInResponse>("/api/auth/sign-in", req);
}

export async function signUp(req: SignUpRequest): Promise<void> {
  return http.post<void>("/api/auth/sign-up", req);
}

export async function refreshToken(): Promise<void> {
  return http.postSilentAuth<void>("/api/auth/refresh", {});
}
